// @ts-nocheck

import {
  BoostedOddAmericanFootball1ImgPath,
  BoostedOddAmericanFootball2ImgPath,
  BoostedOddBasket1ImgPath,
  BoostedOddBasket2ImgPath,
  BoostedOddBasket3ImgPath,
  BoostedOddBasket4ImgPath,
  BoostedOddBasket5ImgPath,
  BoostedOddBasket6ImgPath,
  BoostedOddBasket7ImgPath,
  BoostedOddBoxing1ImgPath,
  BoostedOddDarts1ImgPath,
  BoostedOddFormulaOne1ImgPath,
  BoostedOddFutsal1ImgPath,
  BoostedOddGolf1ImgPath,
  BoostedOddHandball1ImgPath,
  BoostedOddIceHockey1ImgPath,
  BoostedOddMultisports1ImgPath,
  BoostedOddMultisports2ImgPath,
  BoostedOddRugby1ImgPath,
  BoostedOddRugby2ImgPath,
  BoostedOddSkiing1ImgPath,
  BoostedOddSoccer1ImgPath,
  BoostedOddSoccer10ImgPath,
  BoostedOddSoccer11ImgPath,
  BoostedOddSoccer12ImgPath,
  BoostedOddSoccer13ImgPath,
  BoostedOddSoccer15ImgPath,
  BoostedOddSoccer16ImgPath,
  BoostedOddSoccer2ImgPath,
  BoostedOddSoccer3ImgPath,
  BoostedOddSoccer5ImgPath,
  BoostedOddSoccer6ImgPath,
  BoostedOddSoccer7ImgPath,
  BoostedOddSoccer8ImgPath,
  BoostedOddSoccer9ImgPath,
  BoostedOddTennis1ImgPath,
  BoostedOddTennis2ImgPath,
  BoostedOddTennis3ImgPath,
  BoostedOddTennis4ImgPath,
} from '../assets/img/boosted-odd';
import {
  BoostedOddCycling1ImgPath,
  BoostedOddESports1ImgPath,
  BoostedOddESports2ImgPath,
  BoostedOddESports3ImgPath,
  BoostedOddESports4ImgPath,
  BoostedOddFutsal2ImgPath,
  BoostedOddHandball2ImgPath,
  BoostedOddPadel1ImgPath,
  BoostedOddTennis5ImgPath,
} from '../assets/img/boosted-odd/index';
import {
  BigBoostedOddSpritesheetBasket1DEImgPath,
  BigBoostedOddSpritesheetBasket1ENImgPath,
  BigBoostedOddSpritesheetBasket1ESImgPath,
  BigBoostedOddSpritesheetBasket1FRImgPath,
  BigBoostedOddSpritesheetBasket1PTImgPath,
  BigBoostedOddSpritesheetRugby1DEImgPath,
  BigBoostedOddSpritesheetRugby1ENImgPath,
  BigBoostedOddSpritesheetRugby1ESImgPath,
  BigBoostedOddSpritesheetRugby1FRImgPath,
  BigBoostedOddSpritesheetRugby1PTImgPath,
  BigBoostedOddSpritesheetSoccer1DEImgPath,
  BigBoostedOddSpritesheetSoccer1ENImgPath,
  BigBoostedOddSpritesheetSoccer1ESImgPath,
  BigBoostedOddSpritesheetSoccer1FRImgPath,
  BigBoostedOddSpritesheetSoccer1PTImgPath,
  BigBoostedOddSpritesheetSoccer2DEImgPath,
  BigBoostedOddSpritesheetSoccer2ENImgPath,
  BigBoostedOddSpritesheetSoccer2ESImgPath,
  BigBoostedOddSpritesheetSoccer2FRImgPath,
  BigBoostedOddSpritesheetSoccer2PTImgPath,
  BigBoostedOddSpritesheetSoccer3DEImgPath,
  BigBoostedOddSpritesheetSoccer3ENImgPath,
  BigBoostedOddSpritesheetSoccer3ESImgPath,
  BigBoostedOddSpritesheetSoccer3FRImgPath,
  BigBoostedOddSpritesheetSoccer3PTImgPath,
  BigBoostedOddSpritesheetTennis1DEImgPath,
  BigBoostedOddSpritesheetTennis1ENImgPath,
  BigBoostedOddSpritesheetTennis1ESImgPath,
  BigBoostedOddSpritesheetTennis1FRImgPath,
  BigBoostedOddSpritesheetTennis1PTImgPath,
} from '../assets/img/spritesheets/big-boosted-odd';
import {
  BigBoostedOddLogoDE,
  BigBoostedOddLogoEN,
  BigBoostedOddLogoES,
  BigBoostedOddLogoFR,
  BoostedOddLogoDE,
  BoostedOddLogoES,
  BoostedOddLogoFR,
} from '../assets/svg/boosted-odd';
import { Locales } from '../types/common';
import { SportIds } from '../types/sports';

export const BoostedSportsByCategories = {
  800000394: SportIds.SOCCER,
  800000404: SportIds.BASKETBALL,
  800000468: SportIds.BASEBALL,
  800000406: SportIds.ICEHOCKEY,
  800000001: SportIds.TENNIS,
  800000412: SportIds.HANDBALL,
  800000425: SportIds.GOLF,
  800000434: SportIds.MOTO,
  800000403: SportIds.RUGBY,
  800000456: SportIds.WINTER_SPORTS,
  800000402: SportIds.FOOTBALL,
  800000430: SportIds.CYCLING,
  800000466: SportIds.SNOOKER,
  800000472: SportIds.FORMULA_1,
  800000597: SportIds.VOLLEYBALL,
  800000599: SportIds.MMA,
  800000600: SportIds.BOXING,
  800000601: SportIds.DARTS,
  800000602: SportIds.FUTSAL,
  800000603: SportIds.PADEL,
  800000716: SportIds.ATHLETICS,
  800000652: SportIds.PETANQUE,
  800000687: SportIds.BIATHLON,
  800000689: SportIds.ALPINE,
  800000714: SportIds.CROSS_COUNTRY,
  800000717: SportIds.SWIMMING,
  800000719: SportIds.SOCCER_7,
  800000718: SportIds.ESPORT_COUNTER_STRIKE,
  800000721: SportIds.RUGBY_LEAGUE,
  800000754: SportIds.RUGBY_7S,
  800000395: null, // Multisports
  800000817: SportIds.BADMINTON,
  800000794: SportIds.WATERPOLO,
};

export const BoostedOddLogoByLang = new Proxy(
  {
    [Locales.DE]: BoostedOddLogoDE,
    [Locales.FR]: BoostedOddLogoFR,
    [Locales.ES]: BoostedOddLogoES,
  },
  {
    get: (target, key) => {
      if (target[key]) {
        return target[key];
      }
      return BoostedOddLogoFR;
    },
  },
);

export const BigBoostedOddLogoByLang = new Proxy(
  {
    [Locales.DE]: BigBoostedOddLogoDE,
    [Locales.FR]: BigBoostedOddLogoFR,
    [Locales.ES]: BigBoostedOddLogoES,
    [Locales.EN]: BigBoostedOddLogoEN,
  },
  {
    get: (target, key) => {
      if (target[key]) {
        return target[key];
      }
      return BigBoostedOddLogoEN;
    },
  },
);

export const BoostedOddImgPathsByTournamentId = new Proxy(
  {
    900002484: [BoostedOddAmericanFootball1ImgPath, BoostedOddAmericanFootball2ImgPath],
    900002486: [
      BoostedOddBasket1ImgPath,
      BoostedOddBasket2ImgPath,
      BoostedOddBasket3ImgPath,
      BoostedOddBasket4ImgPath,
      BoostedOddBasket5ImgPath,
      BoostedOddBasket6ImgPath,
      BoostedOddBasket7ImgPath,
    ],
    900004864: [BoostedOddBoxing1ImgPath],
    900004865: [BoostedOddBoxing1ImgPath],

    900004866: [BoostedOddDarts1ImgPath],
    900003006: [BoostedOddFormulaOne1ImgPath],
    900002671: [BoostedOddGolf1ImgPath],
    900002771: [BoostedOddHandball1ImgPath, BoostedOddHandball2ImgPath],
    900002489: [BoostedOddIceHockey1ImgPath],
    900004867: [BoostedOddFutsal1ImgPath, BoostedOddFutsal2ImgPath],
    900002472: [BoostedOddMultisports1ImgPath, BoostedOddMultisports2ImgPath],
    900002485: [BoostedOddRugby1ImgPath, BoostedOddRugby2ImgPath],
    900005779: [BoostedOddRugby1ImgPath, BoostedOddRugby2ImgPath],
    900005780: [BoostedOddRugby1ImgPath, BoostedOddRugby2ImgPath],
    900005778: [BoostedOddRugby1ImgPath, BoostedOddRugby2ImgPath],
    900005913: [BoostedOddRugby1ImgPath, BoostedOddRugby2ImgPath],
    900005716: [BoostedOddSkiing1ImgPath],
    900002471: [
      BoostedOddSoccer1ImgPath,
      BoostedOddSoccer2ImgPath,
      BoostedOddSoccer3ImgPath,
      BoostedOddSoccer5ImgPath,
      BoostedOddSoccer6ImgPath,
      BoostedOddSoccer7ImgPath,
      BoostedOddSoccer8ImgPath,
      BoostedOddSoccer9ImgPath,
      BoostedOddSoccer10ImgPath,
      BoostedOddSoccer11ImgPath,
      BoostedOddSoccer12ImgPath,
      BoostedOddSoccer13ImgPath,
      BoostedOddSoccer15ImgPath,
      BoostedOddSoccer16ImgPath,
    ],
    900002470: [
      BoostedOddTennis1ImgPath,
      BoostedOddTennis2ImgPath,
      BoostedOddTennis3ImgPath,
      BoostedOddTennis4ImgPath,
      BoostedOddTennis5ImgPath,
    ],
    900002680: [BoostedOddCycling1ImgPath],
    900007240: [BoostedOddSoccer16ImgPath],

    900005890: [
      BoostedOddESports1ImgPath,
      BoostedOddESports2ImgPath,
      BoostedOddESports3ImgPath,
      BoostedOddESports4ImgPath,
    ],
    900004870: [BoostedOddPadel1ImgPath],
  },
  {
    get: (target, key) => {
      if (target[key]) {
        return target[key];
      }
      return [];
    },
  },
);

export const BigBoostedOddSpritesheetPathsByLangByTournamentId = {
  [Locales.DE]: {
    900002471: [
      BigBoostedOddSpritesheetSoccer1DEImgPath,
      BigBoostedOddSpritesheetSoccer2DEImgPath,
      BigBoostedOddSpritesheetSoccer3DEImgPath,
    ],
    900002470: [BigBoostedOddSpritesheetTennis1DEImgPath],
    900002486: [BigBoostedOddSpritesheetBasket1DEImgPath],
    900002485: [BigBoostedOddSpritesheetRugby1DEImgPath],
    900005779: [BigBoostedOddSpritesheetRugby1DEImgPath],
    900005780: [BigBoostedOddSpritesheetRugby1DEImgPath],
    900005778: [BigBoostedOddSpritesheetRugby1DEImgPath],
    900005913: [BigBoostedOddSpritesheetRugby1DEImgPath],
  },
  [Locales.ES]: {
    900002471: [
      BigBoostedOddSpritesheetSoccer1ESImgPath,
      BigBoostedOddSpritesheetSoccer2ESImgPath,
      BigBoostedOddSpritesheetSoccer3ESImgPath,
    ],
    900002470: [BigBoostedOddSpritesheetTennis1ESImgPath],
    900002486: [BigBoostedOddSpritesheetBasket1ESImgPath],
    900002485: [BigBoostedOddSpritesheetRugby1ESImgPath],
    900005779: [BigBoostedOddSpritesheetRugby1ESImgPath],
    900005780: [BigBoostedOddSpritesheetRugby1ESImgPath],
    900005778: [BigBoostedOddSpritesheetRugby1ESImgPath],
    900005913: [BigBoostedOddSpritesheetRugby1ESImgPath],
  },
  [Locales.FR]: {
    900002471: [
      BigBoostedOddSpritesheetSoccer1FRImgPath,
      BigBoostedOddSpritesheetSoccer2FRImgPath,
      BigBoostedOddSpritesheetSoccer3FRImgPath,
    ],
    900002470: [BigBoostedOddSpritesheetTennis1FRImgPath],
    900002486: [BigBoostedOddSpritesheetBasket1FRImgPath],
    900002485: [BigBoostedOddSpritesheetRugby1FRImgPath],
    900005779: [BigBoostedOddSpritesheetRugby1FRImgPath],
    900005780: [BigBoostedOddSpritesheetRugby1FRImgPath],
    900005778: [BigBoostedOddSpritesheetRugby1FRImgPath],
    900005913: [BigBoostedOddSpritesheetRugby1FRImgPath],
  },
  [Locales.EN]: {
    900002471: [
      BigBoostedOddSpritesheetSoccer1ENImgPath,
      BigBoostedOddSpritesheetSoccer2ENImgPath,
      BigBoostedOddSpritesheetSoccer3ENImgPath,
    ],
    900002470: [BigBoostedOddSpritesheetTennis1ENImgPath],
    900002486: [BigBoostedOddSpritesheetBasket1ENImgPath],
    900002485: [BigBoostedOddSpritesheetRugby1ENImgPath],
    900005779: [BigBoostedOddSpritesheetRugby1ENImgPath],
    900005780: [BigBoostedOddSpritesheetRugby1ENImgPath],
    900005778: [BigBoostedOddSpritesheetRugby1ENImgPath],
    900005913: [BigBoostedOddSpritesheetRugby1ENImgPath],
  },
  [Locales.PT]: {
    900002471: [
      BigBoostedOddSpritesheetSoccer1PTImgPath,
      BigBoostedOddSpritesheetSoccer2PTImgPath,
      BigBoostedOddSpritesheetSoccer3PTImgPath,
    ],
    900002470: [BigBoostedOddSpritesheetTennis1PTImgPath],
    900002486: [BigBoostedOddSpritesheetBasket1PTImgPath],
    900002485: [BigBoostedOddSpritesheetRugby1PTImgPath],
    900005779: [BigBoostedOddSpritesheetRugby1PTImgPath],
    900005780: [BigBoostedOddSpritesheetRugby1PTImgPath],
    900005778: [BigBoostedOddSpritesheetRugby1PTImgPath],
    900005913: [BigBoostedOddSpritesheetRugby1PTImgPath],
  },
};
